// CDHA Service for handling medical imaging data
const SECRET_KEY = process.env.REACT_APP_SECRETKEY;

const cdhaService = {
  /**
   * Fetch CDHA data by extern ID
   * @param {string} externId - The external ID for the CDHA record
   * @returns {Promise} - Promise with CDHA data
   */
  async getCdhaById(externId) {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_CRM_ENDPOINT_URL}/en/api/v1.0/KetQuaCdha/cdha/${SECRET_KEY}?id=${externId}`,
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const json = await response.json();
      return json.data;
    } catch (error) {
      console.error("Error fetching CDHA data:", error);
      throw error;
    }
  },

  /**
   * Check if URL is a PDF
   * @param {string} url - URL to check
   * @returns {boolean} - True if PDF
   */
  isPdf(url) {
    return url.toLowerCase().endsWith(".pdf");
  },

  /**
   * Format image gallery items from URLs
   *
   * Nhận cả hai dạng dữ liệu backend đang trả về:
   *  - [{ original, thumbnail, description }] của endpoint KetQuaCdha/cdha
   *  - ["http://...", ...] của WareHouseDetailDto (Services[].imageUrls, app
   *    mobile dùng dạng này)
   *
   * @param {Array} urls - Array of URL objects hoặc mảng chuỗi URL
   * @returns {Array} - Formatted gallery items
   */
  formatGalleryItems(urls) {
    if (!Array.isArray(urls)) return [];

    return urls.map((raw) => {
      // Mảng chuỗi: ảnh gốc cũng chính là ảnh thu nhỏ, giống mobile.
      const item =
        typeof raw === "string" ? { original: raw, thumbnail: raw } : raw;
      const url = item.original;

      // Check if PDF
      if (this.isPdf(url)) {
        return {
          original: item.thumbnail,
          thumbnail: item.thumbnail,
          description: item?.description || "",
          isPdf: true,
          pdfUrl: url,
        };
      }

      // Regular image
      return {
        original: url,
        thumbnail: item.thumbnail || url,
        description: item?.description || "",
        isPdf: false,
      };
    });
  },

  /**
   * Get panel title based on type
   * @param {number} typeCls - Classification type
   * @returns {string} - Panel title
   */
  getPanelTitle(typeCls) {
    return typeCls === 1 ? "Kết luận" : "Kết quả";
  },
};

export { cdhaService };
